export default __webpack_public_path__ + "static/media/base-plaque-one.6efa0759.png";